import * as React from "react";
import { InteractivePromptBadge } from "./PromptBadge/PromptBadge";
import { PromptBadgeGroup } from "./PromptBadge/PromptBadgeGroup";
import type { InteractivePromptBadgesProps } from "./PromptBadges.types";
export type DisplayMode = "iconOnly" | "textOnly" | "iconAndText";

export const InteractivePromptBadges: React.FC<
  InteractivePromptBadgesProps
> = ({
  badges,
  maxNumber,
  displayMode,
  tagSize = "medium",
  labelWrapper,
  appearance,
}) => {
  badges = badges.filter((badge) => !!badge.onAction);
  const badgesSlice = badges.slice(0, maxNumber);
  const extraBadges = badges.slice(maxNumber);

  if (!badges || badges.length === 0) {
    return null;
  }

  return (
    <PromptBadgeGroup extraBadges={extraBadges} tagSize={tagSize}>
      {badgesSlice.map((badge) => (
        <InteractivePromptBadge
          key={badge.id}
          badge={badge}
          tagSize={tagSize}
          displayMode={displayMode}
          labelWrapper={labelWrapper}
          appearance={appearance}
          withOptions={badge.needsFile}
        />
      ))}
    </PromptBadgeGroup>
  );
};

InteractivePromptBadges.displayName = "InteractivePromptBadges";
